import type { Speaker } from "src/types";

export const DEFAULT_SPEAKERS: Speaker[] = [
  {
    id: 1,
    name: "Marwah Cherry",
    first_name: "Marwah",
    last_name: "Cherry",
    headline: "CEO, Acme Inc. ",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/hazel/images/headshot-1.74b41f06.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 2,
    name: "Isabella Ferghal",
    first_name: "Isabella",
    last_name: "Ferghal",
    headline: "Sustainable Ops Manager, Globex",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/hazel/images/headshot-2.78686e36.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 3,
    name: "Clifford Carey",
    first_name: "Clifford",
    last_name: "Carey",
    headline: "Founder, Ecmy",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/hazel/images/headshot-3.8b5e9f8f.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 4,
    name: "Farraz Gale",
    first_name: "Farraz",
    last_name: "Gale",
    headline: "Advocacy Strategy Manager, ACME Inc.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/hazel/images/headshot-4.fa8c176d.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 5,
    name: "Andrea Orlando",
    first_name: "Andrea",
    last_name: "Orlando",
    headline: "Global sustainability manager, Zikakabo",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/hazel/images/headshot-5.4c87b662.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 6,
    name: "Nayla O'Moore",
    first_name: "Nayla",
    last_name: "O'Moore",
    headline: "Design Director, Suzy",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/hazel/images/headshot-6.788afb1c.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 7,
    name: "Aleksandra Walsh",
    first_name: "Aleksandra",
    last_name: "Walsh",
    headline: "Senior Manager, Logistics, ACME Inc.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/hazel/images/headshot-7.6b8a0c44.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 8,
    name: "Eduard Bauer",
    first_name: "Eduard",
    last_name: "Bauer",
    headline: "Head of business development, Venchi",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/hazel/images/headshot-8.75d2e5fe.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
];
